export default __webpack_public_path__ + "static/media/gallery_05.2ec5393d.jpg";